import { render, staticRenderFns } from "./JsonTable.vue?vue&type=template&id=83559158&"
import script from "./JsonTable.vue?vue&type=script&lang=ts&"
export * from "./JsonTable.vue?vue&type=script&lang=ts&"
import style0 from "./JsonTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports